 
import {
    RECEIVE_CATALOGUE_CATEGORIES_NAV
} from "../actions/navActions";
 import {NavState} from "../state/navState";
export const initState = {
    navCategories:[]
}

const NavReducer = (state = initState, action) => {
    switch (action.type) {
        case RECEIVE_CATALOGUE_CATEGORIES_NAV: {
            return {
                ...state,
                loading: false,
                navCategories: action.payload,                
            }
        }       
        
        default:
            return state;
    }
}

export default NavReducer;